import React, { RefObject } from 'react';

interface ExportDropdownProps {
  isExporting: boolean;
  showExportDropdown: boolean;
  onToggle: () => void;
  onPdfExport: () => void;
  onCsvExport: () => void;
  onXlsExport?: () => void;
  showXlsExport?: boolean;
  exportDropdownRef: RefObject<HTMLDivElement>;
}

const ExportDropdown: React.FC<ExportDropdownProps> = ({
  isExporting,
  showExportDropdown,
  onToggle,
  onPdfExport,
  onCsvExport,
  onXlsExport,
  showXlsExport = false,
  exportDropdownRef,
}) => {

  return (
    <div 
      ref={exportDropdownRef}
      style={{ position: 'relative', display: 'inline-block' }}
    >
      <button
        className="action-button"
        about={isExporting ? "Exporting..." : "Export"}
        disabled={isExporting}
        onClick={onToggle}
        style={{
          opacity: isExporting ? 0.6 : 1,
          position: 'relative',
          paddingRight: '30px',
          paddingLeft: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: 'white',
          color: '#333',
        }}
      >
        {isExporting ? 'Exporting...' : 'Export'}
        <span style={{
          display: 'inline-block',
          width: '12px',
          height: '12px',
          backgroundImage: `url('${__dirname}dropdown.png')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          position: 'absolute',
          right: '10px',
        }} />
      </button>
      {showExportDropdown && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: '5px',
          backgroundColor: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          zIndex: 1000,
          width: '100%',
          overflow: 'hidden',
        }}>
          <button
            onClick={onPdfExport}
            disabled={isExporting}
            style={{
              width: '100%',
              padding: '10px 15px',
              border: 'none',
              backgroundColor: 'transparent',
              textAlign: 'left',
              cursor: isExporting ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              color: isExporting ? '#999' : '#999',
            }}
            onMouseEnter={(e) => {
              if (!isExporting) {
                e.currentTarget.style.backgroundColor = '#f5f5f5';
                e.currentTarget.style.color = '#333';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#999';
            }}
          >
            {isExporting ? 'Exporting...' : 'as PDF'}
          </button>
          <button
            onClick={onCsvExport}
            disabled={isExporting}
            style={{
              width: '100%',
              padding: '10px 15px',
              border: 'none',
              backgroundColor: 'transparent',
              textAlign: 'left',
              cursor: isExporting ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              color: isExporting ? '#999' : '#999',
            }}
            onMouseEnter={(e) => {
              if (!isExporting) {
                e.currentTarget.style.backgroundColor = '#f5f5f5';
                e.currentTarget.style.color = '#333';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#999';
            }}
          >
            {isExporting ? 'Exporting...' : 'as CSV'}
          </button>
          {showXlsExport && onXlsExport && (
            <button
              onClick={onXlsExport}
              disabled={isExporting}
              style={{
                width: '100%',
                padding: '10px 15px',
                border: 'none',
                backgroundColor: 'transparent',
                textAlign: 'left',
                cursor: isExporting ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                color: isExporting ? '#999' : '#999',
              }}
              onMouseEnter={(e) => {
                if (!isExporting) {
                  e.currentTarget.style.backgroundColor = '#f5f5f5';
                  e.currentTarget.style.color = '#333';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#999';
              }}
            >
              {isExporting ? 'Exporting...' : 'as XLS'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ExportDropdown;
